<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item) && acessoModuloGrupo(item)"
    class="nav-item has-sub"
    :class="{
      'open': isOpen,
      'disabled': item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <b-link
      class="d-flex align-items-center"
      @click="handleGroupClick"
    > <feather-icon
        :icon="item.icon || 'CircleIcon'"
      />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-collapse
      v-model="isOpen"
      class="menu-content"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from 'bootstrap-vue'
// MODIFICADO: Adicionado 'computed'
import { inject, ref, computed } from '@vue/composition-api'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { acessoModuloGrupo } from '@/auth/utils'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'

// Composition Function
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup'
import mixinVerticalNavMenuGroup from './mixinVerticalNavMenuGroup'

export default {
  name: 'VerticalNavMenuGroup',
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const {
      // isOpen, // <-- REMOVIDO
      isActive,
      // updateGroupOpen, // <-- REMOVIDO
      updateIsActive,
    } = useVerticalNavMenuGroup(props.item)

    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuGroup } = useAclUtils()

    const isVerticalMenuCollapsed = inject('isVerticalMenuCollapsed', ref(false))

    const toggleMenuCollapsed = inject('toggleMenuCollapsed', () => { })

    const openGroups = inject('openGroups', ref([]))
    const setOpenGroup = inject('setOpenGroup', () => { })

    const isOpen = computed(() => openGroups.value.includes(props.item.title))

    const handleGroupClick = () => {
      // Verifica se o menu principal está retraído
      if (isVerticalMenuCollapsed.value) {
        // Se estiver, expande o menu (passando 'false' para "não-retraído")
        toggleMenuCollapsed(false)
      }

      setOpenGroup(props.item.title)
    }

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      // updateGroupOpen, // <-- REMOVIDO
      updateIsActive,
      handleGroupClick, // <-- MODIFICADO

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,

      acessoModuloGrupo,
    }
  },
}
</script>

<style></style>
